/* unplugin-vue-components disabled */import { render } from "./AlbumDetail.vue?vue&type=template&id=21dd8432&ts=true"
import script from "./AlbumDetail.vue?vue&type=script&lang=ts"
export * from "./AlbumDetail.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/albumDetail/AlbumDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21dd8432"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21dd8432', __exports__)) {
    console.log('reload')
    api.reload('21dd8432', __exports__)
  }
  
  module.hot.accept("./AlbumDetail.vue?vue&type=template&id=21dd8432&ts=true", () => {
    console.log('re-render')
    api.rerender('21dd8432', render)
  })

}


export default __exports__